import React from 'react'
import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import CartItem from '../../components/Cart/CartItem'
import CartCheckout from '../../components/Cart/CartCheckout.js'
import UseGetAllItemsCart from '../../CustomHooks/Cart/UseGetAllItemsCart'
import UseDeleteAllItemsCart from '../../CustomHooks/Cart/UseDeleteAllItemsCart'
import UseApplyCoupon from '../../CustomHooks/Cart/UseApplyCoupon'
import { ToastContainer } from 'react-toastify'
import NavBar from '../../components/Layout/NavBar.js'
import Footer from '../../components/Layout/Footer.js'
import { Link } from 'react-router-dom'
import DeletePopUp from '../../components/Layout/DeletePopUp.js'
import UseViewSearchProducts from '../../CustomHooks/Products/UseViewSearchProducts.js'

const CartPage = () => {
    const [ItemsCartNumber, AllCartItems, CouponNameText, priceAfterDiscount, cartId, TotalPrice] = UseGetAllItemsCart()
    const [handleClearCart, show, handleClose, handleShow] = UseDeleteAllItemsCart()
    const [handleApplyCouponFunc, onChangeCouponName] = UseApplyCoupon()
    const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()

    return (
        <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
            <Container className='mh-100-exact '>
                <DeletePopUp show={show} handleDeleteItem={handleClearCart} handleClose={handleClose} />
                {
                    AllCartItems && AllCartItems.products ? (
                        <Row>
                            <div className='dark-color fs-20 fw-bold mt-4 d-inline-block mb-3'> You have <span className='fs-30 orange-color'>{ItemsCartNumber}</span> Items in your Cart </div>
                        </Row>
                    ) : null
                }

                <Row className='d-flex justify-content-center'>
                    <Col lg="8">
                        {
                            AllCartItems && AllCartItems.products ? (
                                AllCartItems.products.map((item, index) => {
                                    if (item.product != null) {
                                        return <CartItem item={item} key={index} />;
                                    }
                                    return null;
                                })
                            ) : (
                                <div className='mh-100-exact d-flex align-items-center flex-column w-100 justify-content-center'>
                                    <h3 className='text-center w-100 fs-60'>Your cart is empty</h3>
                                    <Button className='px-5 py-3 orange-bg fs-30 mt-3'>
                                        <Link to="/" className='text-white'>Continue Shopping</Link>
                                    </Button>
                                </div>
                            )

                        }

                    </Col>
                    {AllCartItems && AllCartItems.products ? (
                        <Col  lg="4">
                            <CartCheckout AllCartItems={AllCartItems} handleApplyCouponFunc={handleApplyCouponFunc} onChangeCouponName={onChangeCouponName} CouponNameText={CouponNameText} TotalPrice={TotalPrice} priceAfterDiscount={priceAfterDiscount} />
                        </Col>
                    ) : null}

                </Row>
                <Row>
                    {AllCartItems && AllCartItems.products ? (<div className='orange-color fs-20 mt-4 d-inline-block' onClick={handleShow} role="button"> Delete All Items</div>) : null}
                </Row>
                <ToastContainer />
            </Container >
            <Footer />
        </>

    )
}

export default CartPage
